module.exports = __webpack_public_path__ + "img/Cover_FS_24.5221710e.jpg";